<!-- 最近チェックしたページ -->
<template>
  <h2 class="com_title1"><span>最近チェックしたページ</span></h2>

  <div class="com_topic_list1">
    <div v-for="item in recentlyViewedListData" :key="item.contentId">
      <div class="meta1">
        <span class="com_tag2">{{ item.categoryName }}</span>
      </div>
      <div class="body1">
        <router-link
          :to="`/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`"
          class="com_link1"
          >{{ item.title }}</router-link
        >
        <span class="small1"
          >［ 閲覧日 <span class="roboto">{{ item.viewDate }}</span> ］</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  getTargetDate,
  getUserInfo,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";

interface Item {
  contentId: string;
  categoryId: string;
  categoryName: string;
  title: string;
  viewDate: string;
  detailPath: string;
  updateFormPath: string;
}
export default defineComponent({
  name: "NewsAreaComponent",
  setup() {
    const recentlyViewedListData = ref<Item[]>([]);
    const { agCode, userId } = getUserInfo();

    onMounted(async () => {
      try {
        outputDebugLogs("最近見たページ一覧取得");

        // 最近見たページ一覧取得API
        const response = await apiAuthClient.post(
          "/api/recentlyViewed/getRecentlyViewedPagesList",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            userId: userId.value,
            agCode: agCode.value,
            targetDate: getTargetDate(""),
          }
        );
        recentlyViewedListData.value = response.data.recentlyViewedListData;
        outputDebugLogs(
          "最近見たページ一覧取得成功 件数：" +
            recentlyViewedListData.value.length
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "最近見たページ一覧取得"));
      } finally {
        //何か入れるかも
      }
    });

    return { recentlyViewedListData };
  },
});
</script>
